import { getProfileDetails } from "../services/operations/userOperations";

export const setFormData = (formType, data) => {
	try {
		// Merge new data with existing data
		const existingData = getFormData(formType) || {};
		const mergedData = { ...existingData, ...data };
		localStorage.setItem(
			`annapurna_${formType}_data`,
			JSON.stringify(mergedData)
		);
	} catch (error) {
		console.error("Error saving form data:", error);
	}
};

export const getFormData = (formType) => {
	try {
		// First try to get from localStorage
		const localData = localStorage.getItem(`annapurna_${formType}_data`);
		if (localData) {
			return JSON.parse(localData);
		}

		// If not in localStorage, try to get from profileData
		const profileData = localStorage.getItem("profileData");
		if (profileData) {
			const parsedProfileData = JSON.parse(profileData);
			switch (formType) {
				case "personal":
					return parsedProfileData.personalDetails;
				case "education":
					return parsedProfileData.educationDetails;
				case "family":
					return parsedProfileData.familyDetails;
				case "partner":
					return parsedProfileData.partnerDetails;
				default:
					return null;
			}
		}
		return null;
	} catch (error) {
		console.error("Error getting form data:", error);
		return null;
	}
};

export const clearFormData = (formType) => {
	try {
		localStorage.removeItem(`annapurna_${formType}_data`);
	} catch (error) {
		console.error("Error clearing form data:", error);
	}
};

export const syncAllFormsWithAPI = async () => {
	try {
		const response = await getProfileDetails();
		if (response.status) {
			// Store entire profile data
			localStorage.setItem("profileData", JSON.stringify(response.data));

			// Update individual form data
			if (response.data.personalDetails) {
				setFormData("personal", response.data.personalDetails);
			}
			if (response.data.educationDetails) {
				setFormData("education", response.data.educationDetails);
			}
			if (response.data.familyDetails) {
				setFormData("family", response.data.familyDetails);
			}
			if (response.data.partnerDetails) {
				setFormData("partner", response.data.partnerDetails);
			}
		}
	} catch (error) {
		console.error("Error syncing forms with API:", error);
	}
};
